(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ch-round-hero-logo"] && !Shopify.designMode) return;
  try {
    (() => {
    const controllerKey = '__chRoundHeroLogoController';
    window[controllerKey]?.destroy?.();

    const selector = '[data-ch-round-hero-logo]';
    const imageCache = new Map();
    const states = new WeakMap();
    const luminanceThreshold = 0.42;

    const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

    const toLinear = (value) => {
      const channel = value / 255;
      return channel <= 0.04045
        ? channel / 12.92
        : Math.pow((channel + 0.055) / 1.055, 2.4);
    };

    const setTone = (logo, tone) => {
      logo.dataset.tone = tone === 'dark' ? 'dark' : 'light';
    };

    const loadSampleImage = (src) => {
      if (imageCache.has(src)) return imageCache.get(src);

      const promise = new Promise((resolve, reject) => {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.decoding = 'async';
        image.onload = () => resolve(image);
        image.onerror = reject;
        image.src = src;
      });

      imageCache.set(src, promise);
      return promise;
    };

    const getMediaAtCenter = (hero, centerX, centerY) => {
      const media = Array.from(hero.querySelectorAll('.hero__media-grid img')).filter((image) => {
        const rect = image.getBoundingClientRect();
        const style = getComputedStyle(image);

        return (
          rect.width > 0 &&
          rect.height > 0 &&
          style.display !== 'none' &&
          style.visibility !== 'hidden'
        );
      });

      return (
        media.find((image) => {
          const rect = image.getBoundingClientRect();
          return (
            centerX >= rect.left &&
            centerX <= rect.right &&
            centerY >= rect.top &&
            centerY <= rect.bottom
          );
        }) || media[0]
      );
    };

    const parsePosition = (token) => {
      const keywordPositions = {
        left: 0,
        top: 0,
        center: 0.5,
        right: 1,
        bottom: 1,
      };

      if (token in keywordPositions) return keywordPositions[token];
      if (token.endsWith('%')) {
        const value = Number.parseFloat(token);
        if (Number.isFinite(value)) return clamp(value / 100, 0, 1);
      }

      return 0.5;
    };

    const getMediaMapping = (media, sampleImage, mediaRect) => {
      const style = getComputedStyle(media);
      const positionParts = style.objectPosition.trim().split(/\s+/);
      const positionX = parsePosition(positionParts[0] || '50%');
      const positionY = parsePosition(positionParts[1] || '50%');
      const naturalWidth = sampleImage.naturalWidth;
      const naturalHeight = sampleImage.naturalHeight;
      const fit = style.objectFit || 'fill';

      if (fit === 'fill') {
        return {
          sourceXAt: (displayX) => displayX * naturalWidth / mediaRect.width,
          sourceYAt: (displayY) => displayY * naturalHeight / mediaRect.height,
          sourcePerDisplayX: naturalWidth / mediaRect.width,
          sourcePerDisplayY: naturalHeight / mediaRect.height,
        };
      }

      const containScale = Math.min(
        mediaRect.width / naturalWidth,
        mediaRect.height / naturalHeight
      );
      let scale = containScale;

      if (fit === 'cover') {
        scale = Math.max(
          mediaRect.width / naturalWidth,
          mediaRect.height / naturalHeight
        );
      } else if (fit === 'none') {
        scale = 1;
      } else if (fit === 'scale-down') {
        scale = Math.min(1, containScale);
      }

      const renderedWidth = naturalWidth * scale;
      const renderedHeight = naturalHeight * scale;
      const offsetX = (mediaRect.width - renderedWidth) * positionX;
      const offsetY = (mediaRect.height - renderedHeight) * positionY;

      return {
        sourceXAt: (displayX) => (displayX - offsetX) / scale,
        sourceYAt: (displayY) => (displayY - offsetY) / scale,
        sourcePerDisplayX: 1 / scale,
        sourcePerDisplayY: 1 / scale,
      };
    };

    const sampleContrast = async (logo) => {
      const mode = logo.dataset.contrastMode || 'auto';

      if (mode === 'light' || mode === 'dark') {
        setTone(logo, mode);
        return;
      }

      const hero = logo.closest('.hero');
      const heroContainer = hero?.querySelector('.hero__container') || hero;

      if (!hero || !heroContainer) {
        setTone(logo, 'light');
        return;
      }

      if (logo.parentElement !== heroContainer) {
        heroContainer.appendChild(logo);
      }

      const heroRect = heroContainer.getBoundingClientRect();
      const mark = logo.querySelector('.ch-round-hero-logo__mark');
      const markRect = mark?.getBoundingClientRect();
      const centerX = markRect ? markRect.left + markRect.width / 2 : heroRect.left + heroRect.width / 2;
      const centerY = markRect ? markRect.top + markRect.height / 2 : heroRect.top + heroRect.height / 2;
      const media = getMediaAtCenter(hero, centerX, centerY);
      const mediaSource = media?.currentSrc || media?.src;

      if (!mediaSource) {
        setTone(logo, 'light');
        return;
      }

      try {
        const sampleImage = await loadSampleImage(mediaSource);
        const mediaRect = media.getBoundingClientRect();

        if (!sampleImage.naturalWidth || !sampleImage.naturalHeight || !mediaRect.width || !mediaRect.height) {
          throw new Error('Hero image is not ready for contrast sampling.');
        }

        const localX = centerX - mediaRect.left;
        const localY = centerY - mediaRect.top;
        const mapping = getMediaMapping(media, sampleImage, mediaRect);
        const sourceCenterX = mapping.sourceXAt(localX);
        const sourceCenterY = mapping.sourceYAt(localY);

        if (
          sourceCenterX < 0 ||
          sourceCenterX > sampleImage.naturalWidth ||
          sourceCenterY < 0 ||
          sourceCenterY > sampleImage.naturalHeight
        ) {
          throw new Error('Logo center falls outside the rendered hero image.');
        }

        const markSize = mark?.getBoundingClientRect().width || 128;
        const sampleDisplaySize = clamp(markSize * 0.72, 64, 220);
        let sourceWidth = sampleDisplaySize * mapping.sourcePerDisplayX;
        let sourceHeight = sampleDisplaySize * mapping.sourcePerDisplayY;

        sourceWidth = clamp(sourceWidth, 1, sampleImage.naturalWidth);
        sourceHeight = clamp(sourceHeight, 1, sampleImage.naturalHeight);

        let sourceX = sourceCenterX - sourceWidth / 2;
        let sourceY = sourceCenterY - sourceHeight / 2;
        sourceX = clamp(sourceX, 0, sampleImage.naturalWidth - sourceWidth);
        sourceY = clamp(sourceY, 0, sampleImage.naturalHeight - sourceHeight);

        const canvas = document.createElement('canvas');
        canvas.width = 32;
        canvas.height = 32;

        const context = canvas.getContext('2d', { willReadFrequently: true });
        if (!context) throw new Error('Canvas context is unavailable.');

        context.drawImage(
          sampleImage,
          sourceX,
          sourceY,
          sourceWidth,
          sourceHeight,
          0,
          0,
          canvas.width,
          canvas.height
        );

        const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
        const luminances = [];

        for (let index = 0; index < pixels.length; index += 4) {
          if (pixels[index + 3] < 32) continue;

          const red = toLinear(pixels[index]);
          const green = toLinear(pixels[index + 1]);
          const blue = toLinear(pixels[index + 2]);

          luminances.push(0.2126 * red + 0.7152 * green + 0.0722 * blue);
        }

        if (!luminances.length) throw new Error('No image pixels were available for sampling.');

        luminances.sort((a, b) => a - b);
        const medianLuminance = luminances[Math.floor(luminances.length / 2)];

        setTone(logo, medianLuminance >= luminanceThreshold ? 'dark' : 'light');
      } catch (error) {
        setTone(logo, 'light');
      }
    };

    const teardown = (logo) => {
      const state = states.get(logo);
      if (!state) return;

      state.mediaListeners.forEach(({ image, handler }) => {
        image.removeEventListener('load', handler);
      });
      state.observer?.disconnect();
      states.delete(logo);
    };

    const setup = (logo) => {
      teardown(logo);

      const hero = logo.closest('.hero');
      const heroContainer = hero?.querySelector('.hero__container') || hero;

      if (heroContainer && logo.parentElement !== heroContainer) {
        heroContainer.appendChild(logo);
      }

      const mediaListeners = [];
      const media = hero?.querySelectorAll('.hero__media-grid img') || [];

      media.forEach((image) => {
        const handler = () => sampleContrast(logo);
        image.addEventListener('load', handler);
        mediaListeners.push({ image, handler });
      });

      let observer = null;
      if ('ResizeObserver' in window && heroContainer) {
        observer = new ResizeObserver(() => sampleContrast(logo));
        observer.observe(heroContainer);
      }

      states.set(logo, { observer, mediaListeners });
      sampleContrast(logo);
    };

    const init = (scope = document) => {
      if (scope.matches?.(selector)) setup(scope);
      scope.querySelectorAll?.(selector).forEach(setup);
    };

    const teardownScope = (scope) => {
      if (scope.matches?.(selector)) teardown(scope);
      scope.querySelectorAll?.(selector).forEach(teardown);
    };

    const onDomReady = () => init();
    const onWindowLoad = () => init();
    const onSectionLoad = (event) => init(event.target);
    const onSectionUnload = (event) => teardownScope(event.target);
    const onBlockSelect = (event) => init(event.target);

    let waitingForDomReady = false;

    if (document.readyState === 'loading') {
      waitingForDomReady = true;
      document.addEventListener('DOMContentLoaded', onDomReady, { once: true });
    } else {
      init();
    }

    window.addEventListener('load', onWindowLoad);
    document.addEventListener('shopify:section:load', onSectionLoad);
    document.addEventListener('shopify:section:unload', onSectionUnload);
    document.addEventListener('shopify:block:select', onBlockSelect);

    const destroy = () => {
      if (waitingForDomReady) {
        document.removeEventListener('DOMContentLoaded', onDomReady);
      }
      window.removeEventListener('load', onWindowLoad);
      document.removeEventListener('shopify:section:load', onSectionLoad);
      document.removeEventListener('shopify:section:unload', onSectionUnload);
      document.removeEventListener('shopify:block:select', onBlockSelect);
      document.querySelectorAll(selector).forEach(teardown);

      if (window[controllerKey]?.destroy === destroy) {
        delete window[controllerKey];
      }
    };

    window[controllerKey] = { destroy };
  })();
  } catch(e) { console.error(e); }
})();

})();
